import * as actionTypes from 'store/session/actionTypes';

import { SessionStoreType } from './types';

export const setMainSessionId = (payload: SessionStoreType['mainSessionId']) =>
    ({
        type: actionTypes.SET_MAIN_SESSION_ID,
        payload,
    } as const);
